// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"Title_titleWrapper__84Ts7","bold":"Title_bold__6peuF","subtitle":"Title_subtitle__95YNn"};